import { Box, Typography } from '@mui/material';
import React from 'react';
import HelpIconPopover from '../HelpIconPopover';

import '../../../styles/report.css';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);

/*
  Using a <style> tag directly in a component is generally not standard practice,
  but it is the most effective way to encapsulate print-only styles within a single
  file modification as requested. The @media print query ensures these styles
  do not affect the on-screen display.
*/
const PrintStyles = () => (
    <style>
        {`
        @media print {
            .ows-print-container {
                background-color: #fff;
                page-break-inside: avoid;
            }

            .ows-print-container .ows-title {
                font-family: 'Times New Roman', Times, serif;
                font-size: 16pt;
                font-weight: bold;
                text-align: center;
                color: #000;
            }
            
            /* Ensure the interactive popover is not visible in print */
            .ows-print-container .help-icon-popover {
                display: none;
            }
        }
        `}
    </style>
);


const OverallWellnessScore = (props) => {
    const { OWS, PrintView } = props;

    const labelCenter = {
        id: "labelCenter",
        beforeDraw: (chart, args, options) => {
            if (!Array.isArray(options.labels)) {
                return console.error('"options.lables" must be array', options.lables);
            }

            const {
                ctx,
                chartArea: { width, height }
            } = chart;
            const context = ctx.canvas.getContext("2d");
            context.save();

            const labels = options.labels.slice();
            const totalFontSize = labels.reduce((x, y, index) => {
                let prevSize = x[index - 1] || 0;
                x.push(prevSize + y.font.size);
                return x;
            }, []);

            labels.forEach((label, index) => {
                let tpos = [10]
                let textPosition = tpos[index];
                const values = {
                    text: label.text || "?",
                    font: {
                        size: label.font.size || 30,
                        family: label.font.family || "sans-serif",
                        color: label.font.color || "black",
                        style: label.font.style || "normal",
                        unit: label.font.unit || "px"
                    }
                };
                switch (values.font.unit) {
                    case "em":
                        values.font.size = label.font.size * 0.04;
                        textPosition *= 0.8;
                        break;
                    default:
                        break;
                }

                context.font = `${values.font.style} ${values.font.size}${values.font.unit} ${values.font.family}`;
                context.textAlign = "center";
                context.fillStyle = values.font.color;
                context.fillText(values.text, width / 2, height / 2 + textPosition);
            });
            context.restore();
        }
    };

    const WellnessScore = (props) => {
        // Accept PrintView to modify chart options
        const { CurrentOWSValue, HealthAge, OWSText, PrintView } = props;

        const graphcolors = ['#c0c0c0', '#4eb748', '#E7C61E', '#E6323A']
        const GetColor = (score) => {
            const vg = parseInt(score <= 39 ? 3 : score <= 69 ? 2 : score <= 100 ? 1 : 0)
            return graphcolors[vg]
        }

        const Color = GetColor(CurrentOWSValue)
        const data = {
            datasets: [
                {
                    label: OWSText,
                    data: [CurrentOWSValue, 100 - CurrentOWSValue],
                    backgroundColor: [
                        Color,
                        Color + "40"
                    ],
                    borderColor: [
                        'rgba(255, 99, 132, 0)',
                        'rgba(54, 162, 235, 0)',
                    ],
                    borderWidth: 0,
                },
            ],
        }
        const options = {
            responsive: true,
            cutout: '80%',
            // Disable animations for print view to ensure a static image
            animation: PrintView ? false : {
                animateRotate: true,
                render: false,
            },
            events: [],
            tooltips: {
                enabled: false
            },
            plugins: {
                legend: {
                    display: false
                },
                labelCenter: {
                    labels: [
                        {
                            text: CurrentOWSValue,
                            font: {
                                size: 3.25,
                                unit: "rem",
                                color: 'black',
                                style: "bold"
                            }
                        }
                    ]
                }

            }
        }
        const plugins = [labelCenter]
        return <Doughnut data={data} options={options} plugins={plugins} />
    }

    if (PrintView === true) {
        return (
            <>
                <PrintStyles />
                <div className="ows-print-container">
                    <div className="ows-title">
                        {OWS.OWS.Label}
                    </div>
                     {/* Render the chart with PrintView=true to disable animations */}
                    <WellnessScore OWSText={'test'} CurrentOWSValue={OWS.OWS.Score} HealthAge={OWS.HealthAge} PrintView={true} />
                </div>
            </>
        )
    }

    return (
        <Box>
            {props.OWS.OWS.HelpText !== '' && (
                <Typography variant="body1" fontWeight="bold" style={{ textAlign: 'center', fontSize: "20px" }}>
                    {props.OWS.OWS.Label}
                    {/* The className is added for the print CSS to target */}
                    <span className="help-icon-popover">
                        <HelpIconPopover Text={props.OWS.OWS.HelpText} style={{ top: '-10!important' }} />
                    </span>
                </Typography>
            )}
            <Box className="OWS">
                <Box className="OWSCircle">
                    <WellnessScore OWSText={'test'} CurrentOWSValue={props.OWS.OWS.Score} HealthAge={props.OWS.HealthAge} PrintView={false} />
                </Box>
            </Box>
        </Box>
    )
}

export default OverallWellnessScore;